import { render, staticRenderFns } from "./commentCard.vue?vue&type=template&id=2f597395&scoped=true&"
import script from "./commentCard.vue?vue&type=script&lang=js&"
export * from "./commentCard.vue?vue&type=script&lang=js&"
import style0 from "./commentCard.vue?vue&type=style&index=0&id=2f597395&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f597395",
  null
  
)

export default component.exports